module.exports = __webpack_public_path__ + "static/media/Zebronics.42623817.png";